import z from 'zod';

import { zodDateOrString } from '../utils/Zod';
import { NonPerformanceCode } from './NonPerformanceCode';

const NonPerformanceEventDate = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('plainDateRange'),
    startDate: zodDateOrString,
    endDate: zodDateOrString.optional(),
  }),
  z.object({
    type: z.literal('plainDate'),
    date: zodDateOrString,
  }),
  z.object({
    type: z.literal('timestamp'),
    timestamp: zodDateOrString,
  }),
  z.object({
    type: z.literal('none'),
  }),
]);

export const NonPerformanceEvent = z.object({
  code: NonPerformanceCode,
  date: NonPerformanceEventDate,
});

export type NonPerformanceEvent = z.infer<typeof NonPerformanceEvent>;
